<template>
  <div id="companyIntroduct">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>公司简介</span>
      </div>
      <div class="content">
        <div>
<!--          <img :src="img" :alt="tableData.name"
          v-handle-img="$store.state.api + tableData.introduceimg">-->

          <!-- <video class="video" id="bgvid" playsinline="" autoplay muted loop="">
            <source src="../../assets/video/company.mp4" type="video/mp4">
          </video> -->
        </div>
        <div>
          <p>
            鄂尔多斯市安能检测检验有限公司（以下简称公司）成立于二○一七年，是一家检测能力较强、市场占有率真较大的检测检验机构，具有独立法人资格，注册资本1000万元，位于内蒙古自治区鄂尔多斯市东胜区金辉大厦5楼，办公区、实验区等场所共计2000多平方米；同时配备了四十余名专业的检测检验技术人员，其中包括注册安全工程师、高级工程师等数名，专业的检测设备一千台/套，专业检测车辆十余辆。
          </p>
          <p> 
            公司主要从事矿山安全检测检验、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化、安全评价、安全咨询、安全培训、安全标准化
          </p>
          <p>  
            目前公司主要检测范围矿用仪器仪表检测检验、矿用电气设备检测检验、矿用通风设备检测检验、无陨探伤检测检验、矿用车辆检测检验等，几乎覆盖了矿山在用设备所有名录；设有检测检验部、仪器仪表实验室、综合部、业务部、质量技术部、财务部6个部门，从过程到结果，从源头到终端，全方位监管服务。
          </p>
          <p>
            公司依据AQ/T 8006-2018《安全生产检测检验能力的通用要求》、AQ/T 8012-2022《安全生产检测检验机构诚信建设规范》要求，按照资质认定和实验室认可等规范，结合公司实际情况，建立并不断完善管理体系确保持续有效运行，达到法定检测检验机构要求，更好地为企业的安全生产服务。
          </p>
          <p>
            公司始终坚持“诚信、公正、科学、高效”的服务宗旨，以“安全第一、预防为主、综合治理”的方针，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以“安全、高效、优质、诚信”的服务理念，以
          </p>
          <p>
            我们把安全检测质量、速度等服务放在第一位，坚守安全底线，切实推行全面质量管理，坚持“诚信第一、质量第一、科学公正、优质服务”的服务准则。严格执行相关检测检验标准规范，保守客户的商业机密，恪守公正、严谨、精准、高效的质量方针,以科学、严谨的态度坚守职业道德，发挥检测检验机构应有的作用，为矿山安全生产工作做出积极的贡献。
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { listInfo } from '@/api/company'
import imgUrl from '@/assets/images/loading.gif'
export default {
  name: 'companyIntroduct',
  data () {
    return {
      tableData: [],
      total: 0, // 分页总数
      pageNum: 1, // 分页当前页码数
      pageSize: 10, // 分页数量
      search: undefined, // 搜索内容
      img: imgUrl
    }
  },
  methods: {
    async loadList () {
      try {
        const res = await listInfo({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.search
        })
        if (res.code === 200) {
          this.total = res.total
          this.tableData = res.rows[0]
        }
      } catch (error) {
        this.$message.error('未知错误，请重新尝试')
      }
    },
    onSearch () {
      this.pageNum = 10
      this.pageNum = 1
      this.loadList()
    }
  },
  created () {
    // this.loadList()
  }
}
</script>

<style lang='less' scoped>
  @media screen and (max-width: 767px) {
    #companyIntroduct {
      .content {
        > div:first-child {
          width: 100%;
        }
        > div:last-child {
          width: 100%;
        }
      }
    }
  }
  @media screen and (min-width: 767px) {
    #companyIntroduct {
      .content {
        > div:first-child {
          width: 40%;
        }
        > div:last-child {
          width: 56%;
        }
      }
    }
  }
  #companyIntroduct {
    .box-card {
      margin: 0 auto;
      margin-top: 20px;
      width: 90%;
      text-align: left;
    }
    .clearfix {
      span {
        font-size: 20px;
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      > div:first-child {
        flex: 1;
        img {
          width: 100%;
          height: 100%;
        }

        .video {
          width: 95%;
        }
      }
      > div:last-child {
        background-color: rgb(247,247,247);
        padding: 15px;
      }
      p {
        margin: 10px;
        padding: 0;
        text-indent: 24px;
        // color: #919191;
        // font-size: 14px;
        // line-height: 25px;
        // text-align: left;
        // text-indent: 28px;
      }
    }
  }
</style>
